import { text } from "@quickpoint.me/shared";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { useMetrics } from "../../hooks/useMetrics";
import { IsInPortrait } from "../../state/selectors";
import { MousedOverTextHelper } from "../../state/uiAtoms";
import { CreateNewStack, ShowStacks } from "../../state/stackAtoms";
import { TopBarControl } from "../StyledControl";

function NewStackControl() {
  const setTextHelper = useSetRecoilState(MousedOverTextHelper);
  const isInPortrait = useRecoilValue(IsInPortrait);
  const setCreateNewStack = useSetRecoilState(CreateNewStack);
  const setShowStacks = useSetRecoilState(ShowStacks);
  const { track } = useMetrics();

  const handleClick = () => {
    setShowStacks(true);
    setCreateNewStack(true);
    // intent only — story_created fires in useCreateStack on success
    track('story_create_opened');
  };

  const mouseOver = () => {
    setTextHelper(text.controls.newStack);
  };

  const mouseLeave = () => {
    setTextHelper(undefined);
  };

  return (
    <TopBarControl
      $isInPortrait={isInPortrait}
      data-testid="new-stack-control"
      onClick={handleClick}
      onMouseOver={mouseOver}
      onMouseLeave={mouseLeave}
      aria-label={text.controls.newStack}
    >
      {text.controls.newStack}
    </TopBarControl>
  );
}

export default NewStackControl;
